export class ErrorUploadImage extends Error {
  constructor(file: File | null) {
    const genericErrorText = `Couldn't upload file${file ? `: ${file.name}.` : ''}`;

    super(genericErrorText);

    this.message = genericErrorText;
  }
}
